import { render, staticRenderFns } from "./ExpedicaoFilterBar.vue?vue&type=template&id=c6fb8990"
import script from "./ExpedicaoFilterBar.vue?vue&type=script&lang=js"
export * from "./ExpedicaoFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports